import React from "react";
import { Link } from 'react-router-dom';

const StoryMenu = ({ subMenuType }) => {
  return (
    <div className="w-[calc(100%-44px)] max-w-[540px] py-[30px] flex items-center justify-between mx-auto">
      <Link 
        to="/story/question"
        className={`flex-1 flex justify-center items-center h-[46px] md:h-[52px] border ${
          subMenuType === 0 
            ? 'border-[#FFEFC6] bg-[#FEF8E8] text-[#FEC009]' 
            : 'border-[#e9eaee] bg-[#f5f5f5] text-[#c4c4c4]'
        } font-semibold text-sm md:text-lg rounded-l-lg`}
      >
        궁금해요
      </Link>
      <Link 
        to="/story/timeline"
        className={`flex-1 flex justify-center items-center h-[46px] md:h-[52px] border ${
          subMenuType === 1 
            ? 'border-[#FFEFC6] bg-[#FEF8E8] text-[#FEC009]' 
            : 'border-[#e9eaee] bg-[#f5f5f5] text-[#c4c4c4]'
        } font-semibold text-sm md:text-lg`}
      >
        이 시기엔
      </Link>
      <Link 
        to="/story/riskypregnancy"
        className={`flex-1 flex justify-center items-center h-[46px] md:h-[52px] border ${
          subMenuType === 2 
            ? 'border-[#FFEFC6] bg-[#FEF8E8] text-[#FEC009]' 
            : 'border-[#e9eaee] bg-[#f5f5f5] text-[#c4c4c4]'
        } font-semibold text-sm md:text-lg rounded-r-lg`}
      >
        고위험 임신
      </Link>
    </div>
  );
};

export default StoryMenu;
